import { render, staticRenderFns } from "./SemiologiaNutricional.vue?vue&type=template&id=eb8bb71e&scoped=true"
import script from "./SemiologiaNutricional.vue?vue&type=script&lang=js"
export * from "./SemiologiaNutricional.vue?vue&type=script&lang=js"
import style0 from "./SemiologiaNutricional.vue?vue&type=style&index=0&id=eb8bb71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8bb71e",
  null
  
)

export default component.exports